import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const HouseholdOnboardingStatusRibbonRowFragment = graphql(/* GraphQL */ `
  fragment HouseholdOnboardingStatusRibbonRow on OnboardingCockpitRow {
    id
    uuid
    householdUuid
    status
    blockedReason
    householdName
    primaryClientName
    primaryClientEmail
    accountsTransferred
    accountsTotal
    estAum
    transferredAmount
    msaSigned
    msaTotal
    lastContactedAt
    inviteRecipients {
      id
      name
      email
      role
      submitted
      canResend
    }
  }
`);

export type HouseholdOnboardingStatusRibbonRow = ResultOf<typeof HouseholdOnboardingStatusRibbonRowFragment>;
